/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Icon } from '../Icon';
import * as styles from './index.styles';

export const ZoomInUIControl = () => (
  <button css={styles.baseZoomControls}>
    <Icon name="plus" customCss={styles.plusIcon} />
    <span css={styles.underline} />
  </button>
);

ZoomInUIControl.displayName = 'Map/ZoomInUIControl';

export const ZoomOutUIControl = () => (
  <button css={styles.baseZoomControls}>
    <i css={styles.minusIcon} />
  </button>
);

ZoomOutUIControl.displayName = 'Map/ZoomOutUIControl';
